<div class="not-allowed" [ngClass]="fontSmaller ? 'px-0' : 'px-1'">
  <div *ngIf="isAndroid">
    <div class="card m-0 rounded bg-transparent p-0 shadow-none">
      <img
        [src]="emptyImage"
        class="card-img"
        alt="empty"
        [ngStyle]="{ height: cellHeight }"
      />
      <div class="card-img-overlay p-0">
        <div class="w-100 h-100">
          <div
            class="d-flex align-items-center"
            style="scrollbar-width: thin; padding: 4px 0;"
            [ngClass]="
              this.fontSmaller || this.fontResize
                ? 'overflow-hidden'
                : 'overflow-auto'
            "
          >
            <ng-container
              *ngFor="let option of options; index as index; let last = last"
            >
              <div
                class="px-1 py-1 d-flex align-items-center"
                [ngClass]="optionborder"
                [ngStyle]="optionBgColor"
                [style]="'border:' + outlined_border + 'pointer-events: none;' + 'height: ' + cellHeight + '; box-shadow:' + box_shadow"
              >
                <i *ngIf="option?.icon" class="float-none m-0 ms-1" [ngStyle]="leadingIconColor" [class]="builderService?.getIcon(option?.icon).type == 'mir' ? 'material-icons-outlined' : 'material-icons'">{{ builderService?.getIcon(option?.icon).id }}</i>
                <p
                  class="m-0 text-truncate"
                  [ngStyle]="optionTextColor"
                  [ngClass]="fontSmaller ? 'px-1' : 'px-2'"
                >
                  {{ option.label }}
                </p>
                <!-- <i *ngIf="option?.icon" class="float-none m-0 me-1" [ngStyle]="activeOption[option.id]? leadingSelectedIconColor: leadingIconColor"  [class]="builderService?.getIcon('close').type=='mir'?'material-icons-outlined':'material-icons'" >close</i> -->
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isAndroid">
    <div class="card m-0 rounded bg-transparent p-0 shadow-none">
      <img
        [src]="emptyImage"
        class="card-img"
        alt="empty"
        [ngStyle]="{ height: cellHeight }"
      />
      <div class="card-img-overlay p-0">
        <div
          class="btn-group w-100 h-100"
          role="group"
          aria-label="Basic example"
          [ngClass]="no_cells == 2 && mobileView ? 'm-75 m-auto' : ''"
        >
          <div
            class="d-flex align-items-center"
            style="scrollbar-width: thin; padding: 4px 0;"
            [ngClass]="
              this.fontSmaller || this.fontResize
                ? 'overflow-hidden'
                : 'overflow-auto'
            "
          >
            <ng-container
              *ngFor="let option of options; index as index; let last = last"
            >
              <div
                class="px-1 py-1 d-flex align-items-center"
                [ngClass]="optionborder"
                [ngStyle]="optionBgColor"
                [style]="
                  'border:' +
                  outlined_border +
                  'pointer-events: none;' +
                  'height: ' +
                  cellHeight +
                  '; box-shadow:' +
                  box_shadow
                "
              >
                <i
                  *ngIf="option?.icon"
                  class="float-none m-0 ms-1"
                  [ngStyle]="leadingIconColor"
                  [class]="
                    builderService?.getIcon(option?.icon).type == 'mir'
                      ? 'material-icons-outlined'
                      : 'material-icons'
                  "
                  >{{ builderService?.getIcon(option?.icon).id }}</i
                >
                <p
                  class="m-0 text-truncate"
                  [ngStyle]="optionTextColor"
                  [ngClass]="fontSmaller ? 'px-1' : 'px-2'"
                >
                  {{ option.label }}
                </p>
                <!-- <i *ngIf="option?.icon" class="float-none m-0 me-1" [ngStyle]="activeOption[option.id]? leadingSelectedIconColor: leadingIconColor"  [class]="builderService?.getIcon('close').type=='mir'?'material-icons-outlined':'material-icons'" >close</i> -->
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
